import FadeInOnScroll from '../effects/FadeInOnScroll';
import BlurText from '../effects/BlurText';

export default function SectionIntro({ title, description }) {
  return (
    <FadeInOnScroll className="section-intro">
      <div>
        <h2>
          <BlurText text={title[0]} />
          <br />
          <BlurText text={title[1]} className="muted-heading" delay={140} />
        </h2>
        {description && <p>{description}</p>}
      </div>
    </FadeInOnScroll>
  );
}
